import React, { Component } from "react";
import { Tag } from "antd";

const renderImportanceTag = (i) => {
  const importance = i;
  var color = "#F5F5F5";
  var textColor = "#AB3EAB";
  switch (importance) {
    case "Top":
      color = "#FF97FF";
      break;

    case "High":
      color = "#FFACFF";
      break;

    case "Mid":
      color = "#FFC1FF";
      break;

    case "Low":
      color = "#FFD6FF";
      break;

    default:
      color = "#F5F5F5";
      textColor = "#969696";
      break;
  }
  return (
    <Tag
      color={color}
      style={{ color: `${textColor}`, border: `solid 1px ${textColor}` }}
    >
      {importance}
    </Tag>
  );
};

const renderQualityTag = (q) => {
  const quality = q;
  var color = "#F5F5F5";
  var textColor = "#969696";
  switch (quality) {
    case "FA":
      color = "#9CBDFF";
      textColor = "#3B68C1";
      break;

    case "GA":
      color = "#66FF66";
      textColor = "#0E7432";
      break;

    case "A":
      color = "#66FFFF";
      textColor = "#0E7432";
      break;

    case "B":
      color = "#B2FF66";
      textColor = "#579817";
      break;

    case "C":
      color = "#FFFF66";
      textColor = "#999913";
      break;

    case "Start":
      color = "#FFAA66";
      textColor = "#A7581A";
      break;

    case "Stub":
      color = "#FFA4A4";
      textColor = "#C75353";
      break;

    case "FL":
      color = "#9CBDFF";
      textColor = "#3B68C1";
      break;

    case "List":
      color = "#C7B1FF";
      textColor = "#6F51BC";
      break;

    default:
      color = "#F5F5F5";
      textColor = "#969696";
      break;
  }
  return (
    <Tag
      color={color}
      style={{ color: `${textColor}`, border: `solid 1px ${textColor}` }}
    >
      {quality}
    </Tag>
  );
};

const renderResolutionTag = (r) => {
  const resolution = r;
  var color = "#F5F5F5";
  var textColor = "#1890FF";
  switch (resolution) {
    case "High-res":
      color = "#BAE7FF";
      textColor = "#40A9FF";
      break;

    case "Mid-res":
      color = "#E6F7FF";
      textColor = "#69C0FF";
      break;

    case "Low-res":
      color = "#FFF1F0";
      textColor = "#FF7875";
      break;

    default:
      color = "#F5F5F5";
      textColor = "#1890FF";
      break;
  }
  return (
    <Tag
      color={color}
      style={{ color: `${textColor}`, border: `solid 1px ${textColor}` }}
    >
      {resolution}
    </Tag>
  );
};

export default class AssessmentTag extends Component {
  render() {
    const type = this.props.type;
    const text = this.props.text;
    if (type == "importance") {
      return renderImportanceTag(text);
    } else if (type == "quality") {
      return renderQualityTag(text);
    } else if (type == "resolution") {
      return renderResolutionTag(text);
    } else {
      return (
        <Tag
          color={"#F0F0F0"}
          style={{ color: "#8C8C8C", border: "solid 1px #8C8C8C" }}
        >
          {text}
        </Tag>
      );
    }
  }
}
